/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { createContext } from 'react';
import type { UseProductListDataResult } from './interface';

export const ProductListContext = createContext<UseProductListDataResult>({
  data: undefined,
  sponsoredSkus: [],
  pagedSkuIds: [],
  status: 'idle',
  isFetching: false,
  isSuccess: false,
  isPending: false,
  isError: false,
  isIdle: true,
  productSkuIsFetching: false,
  productSkuIsPending: false,
  loadMoreClicked: false,
  additionalProductSkuDetailsIsFetching: false,
  productSkuPageInformation: {},
  productSkuRawQueryResults: [],
});
